import {computeProgressBarWidth} from "../../controllers/SystemLinearProgressBarController";

export default function SystemAnimatedLinearProgressBar({currentIndex, total}) {
    // Used through the app to display an animated
    // horizontal progress bar

    // BUILD
    return (
        <div className="w-full h-[13px] border-primaryDark3 shadow-[inset_0px_0px_0px_1px_rgba(22,147,227,1)] rounded-full overflow-hidden ">
            <div className="h-[13px] transition-all duration-400 ease-out bg-gradient-to-t from-primaryDark3 to-primaryLight1 rounded-full"
                 style={{width: computeProgressBarWidth(currentIndex, total)}}>
            </div>
        </div>
    )
}